"use strict";

const Select = () => {
    const init = () => {
        $(function() {
            var $select = $('.js-select');
            if($select.length) {
                var $floorplans = $select.find('.js-select-floorplan');
                var $options = $select.find('.js-floorplan-option-toggle');
                var $facades = $select.find('.js-select-facade');
                var $finishes = $select.find('.js-select-facade-finish');
                var $promotions = $select.find('.js-select-promotion');
                var $inclusions = $select.find('.js-select-inclusion');
                var $inclusionTabs = $select.find('.js-compare-tab');
                var $flipToggles = $select.find('.js-flip-toggle');
                var $sections = $select.find('[data-select-section]');
                var $steps = $select.find('.js-progress-tracker-step');
                var $navModule = $select.find('.home-design-progress-tracker.sticky');
                var $scrollTriggers = $select.find('.js-select-scroll-trigger');
                var $form = $select.find('.js-popout .js-download-form');

                $options.on('click', function(){
                    updateSelections($select);
                });

                $flipToggles.on('click', function(){
                    updateSelections($select);
                });

                $facades.on('click', function(){
                    if($(this).hasClass('active')) {
                        $facades.removeClass('active');
                        $finishes.removeClass('active');
                    }else{
                        $facades.removeClass('active');
                        $finishes.filter('[data-facade!="'+$(this).data('id')+'"]').removeClass('active');
                        if(!$finishes.filter('[data-facade="'+$(this).data('id')+'"].active').length){
                            $finishes.filter('[data-facade="'+$(this).data('id')+'"]:first-child').addClass('active');
                        }
                        $(this).addClass('active');
                    }
                    updateSelections($select);
                });
                $finishes.on('click', function(){
                    if($(this).hasClass('active')) {
                        $facades.removeClass('active');
                        $finishes.removeClass('active');
                    }else{
                    $facades.removeClass('active');
                        $finishes.removeClass('active');
                        $(this).addClass('active');
                        $facades.filter('[data-id="'+$(this).data('facade')+'"]').addClass('active');
                    }
                    updateSelections($select);
                });

                $promotions.on('click', function(){
                    if($(this).data('exclusive') == 0){
                        if($(this).hasClass('active')) {
                            $(this).removeClass('active')
                        }else{
                            $(this).addClass('active')
                        }
                    }else{
                        if($(this).hasClass('active')) {
                            $promotions.filter('[data-exclusive="1"]').removeClass('active');
                        }else{
                            $promotions.filter('[data-exclusive="1"]').removeClass('active');
                            $(this).addClass('active')
                        }
                    }
                    updateSelections($select);
                });

                $inclusions.on('click', function(){
                    if(!$(this).hasClass('active')) {
                        $inclusions.removeClass('active')
                        
                        let $otherInclusion = $('.js-compare-column').filter('[data-id="'+$(this).data('id')+'"]').find('.js-select-inclusion')
                        
                        $(this).addClass('active')
                        $otherInclusion.addClass('active')
                        
                        updateSelections($select)
                        refreshInclusionSelect()
                    }
                });

                $inclusionTabs.on('click', function() {
                    var $inclusion = $('.js-compare-column').filter('[data-id="'+$(this).data('id')+'"]').find('.js-select-inclusion');
                    if(!$inclusion.hasClass('active')){
                        $inclusion.trigger('click');
                    }
                });

                function updateSelections($select){
                    if($inclusions.length) {
                        if($inclusions.filter('.active').length) {
                            $promotions.filter('[data-inclusion]').parents('.js-select-promotion-container').hide();
                            $promotions.filter('[data-inclusion="'+$inclusions.filter('.active').data('id')+'"]').parents('.js-select-promotion-container').show();
                            $promotions.filter('[data-inclusion][data-inclusion!="'+$inclusions.filter('.active').data('id')+'"]').removeClass('active');
                        }else{
                            $promotions.filter('[data-inclusion]').parents('.js-select-promotion-container').hide();
                            $promotions.filter('[data-inclusion]').removeClass('active');
                        }
                    }else{
                        $promotions.filter('[data-inclusion]').parents('.js-select-promotion-container').show();
                    }

                    var options_url_param = '';
                    var showPdfButton = true;
                    if($floorplans.filter('.active').length) {
                        options_url_param += '&home=' + $floorplans.filter('.active').data('id');
                        $select.find('.js-select-floorplan-value').text($floorplans.filter('.active').data('text')).parent().addClass('active');
                    }else{
                        $select.find('.js-select-floorplan-value').text('').parent().removeClass('active');
                        showPdfButton = false;
                    }
                    if($options.filter('.active').length) {
                        options_url_param += '&floorplan_options=[';
                        $options.filter('.active').each(function(){
                            options_url_param += $(this).data('id') + ',';
                        });
                        options_url_param = options_url_param.slice(0,-1)
                        options_url_param += ']';
                    }
                    if($select.find('.js-floorplan-image[data-flipped="true"].active').length){
                        options_url_param += '&flipped=1';
                    }
                    if($facades.filter('.active').length) {
                        options_url_param += '&facade=' + $facades.filter('.active').data('id');
                        $select.find('.js-select-facade-value').text($facades.filter('.active').data('text')).parent().addClass('active');
                        $form.find('[name="facade"]').val($facades.filter('.active').data('text'));
                    }else{
                        $select.find('.js-select-facade-value').text('').parent().removeClass('active');
                        if($facades.length){
                            showPdfButton = false;
                        }else{
                            $select.find('.js-select-facade-value').parent().remove();
                        }
                    }
                    if($finishes.filter('.active').length) {
                        options_url_param += '&facade_finish=' + encodeURIComponent($finishes.filter('.active').data('id'));
                    }
                    if($promotions.filter('.active').length) {
                        if($promotions.filter('.active').length > 1) {
                            let promotionIds = '';
                            $promotions.filter('.active').each(function(){
                                promotionIds += $(this).data('id') + ',';
                            });

                            options_url_param += '&promotions=' + promotionIds.slice(0,-1);
                            $select.find('.js-select-promotion-value').text($promotions.filter('.active').length + ' Promotions').parent().addClass('active');
                        }else{
                            options_url_param += '&promotion=' + $promotions.filter('.active').data('id');
                            $select.find('.js-select-promotion-value').text($promotions.filter('.active').data('text')).parent().addClass('active');
                        }
                    }else{
                        $select.find('.js-select-promotion-value').text('').parent().removeClass('active');
                        if($promotions.filter('[data-optional]').length){
                            //Do Nothing, this means promotions are optional, NSW only at the moment
                        }else if($promotions.length && $promotions.filter('[data-optional]').length <= 0){
                            showPdfButton = false;
                        }else{
                            $select.find('.js-select-promotion-value').parent().remove();
                        }
                    }
                    if($inclusions.filter('.active').length) {
                        options_url_param += '&inclusion=' + $inclusions.filter('.active').data('id');
                        $select.find('.js-select-inclusion-value').text($inclusions.filter('.active').data('text')).parent().addClass('active');
                    }else{
                        $select.find('.js-select-inclusion-value').text('').parent().removeClass('active');
                        if($inclusions.length){
                            showPdfButton = false;
                        }else{
                            $select.find('.js-select-inclusion-value').parent().remove();
                        }
                    }
                    options_url_param += '&show_facade_discount=1';
                    options_url_param = options_url_param.substring(1, options_url_param.length);
                    var $btn = $select.find('.module-download-selections .js-popout-trigger');
                    var pdf = $btn.data('base-url') + '?' + options_url_param;
                    if($select.hasClass('shoalhaven-pricing')){
                        pdf += '&shoalhaven=1';
                    }
                    $form.data('download', pdf);
                    if(typeof $form.data('name') !== 'undefined'){
                        pdf = pdf + $form.data('name');
                    }
                    if(typeof $form.data('grant') !== 'undefined'){
                        pdf = pdf + $form.data('grant');
                    }
                    $form.find('[name="pdf"]').val(pdf);
                    if(showPdfButton){
                        $btn.addClass('active');
                    }else{
                        $btn.removeClass('active');
                    }
                }

                updateSelections($select);

                $form.find('[name="fname"], [name="lname"]').on('change', function(){
                    $form.data('name', '&name=' + encodeURIComponent($form.find('[name="fname"]').val()) + '%20' + encodeURIComponent($form.find('[name="lname"]').val()));
                    $form.find('[name="pdf"]').val($form.data('download') + $form.data('name') + ($form.data('grant') !== undefined ? $form.data('grant') : ''));
                });

                $form.find('[name="grant"]').on('change', function(){
                    $form.data('grant', '&grant=' + encodeURIComponent($form.find('[name="grant"]').val()));
                    $form.find('[name="pdf"]').val($form.data('download') + $form.data('name') + ($form.data('grant') !== undefined ? $form.data('grant') : ''));
                });

                $scrollTriggers.on('click', function(){
                    $('html, body').animate({
                        scrollTop: $('[data-select-section="'+$(this).data('id')+'"]').offset().top - $navModule.outerHeight()
                    }, 100);
                });

                var lastScrollPosition = 0;
                var lastSection = -1;

                $(window).on('scroll', function(){
                    var scrollPosition = $(window).scrollTop()
                    if(scrollPosition < lastScrollPosition - 15 || scrollPosition > lastScrollPosition + 15){
                        if(scrollPosition >= lastScrollPosition + 15){
                            $($sections.get().reverse()).each(function(){
                                if(scrollPosition + $(window).outerHeight() >= $(this).offset().top + ($(this).outerHeight() / 2) - $navModule.outerHeight()) {
                                    $steps.removeClass('active');
                                    var $step = $steps.filter('[data-id="'+$(this).data('select-section')+'"]');
                                    if($step.length){
                                        $step.addClass('active');
                                        if(lastSection != $(this).data('select-section')){
                                            $navModule.find('.container').scrollLeft($navModule.find('.container').scrollLeft() + $step.position().left - parseInt($navModule.find('.container').css('padding-left')));
                                        }
                                        lastSection = $(this).data('select-section');
                                    }
                                    return false;
                                }
                            });
                        } else {
                            $sections.each(function(){
                                if(scrollPosition <= $(this).offset().top + $(this).outerHeight() - $navModule.outerHeight()) {
                                    $steps.removeClass('active');
                                    var $step = $steps.filter('[data-id="'+$(this).data('select-section')+'"]');
                                    if($step.length){
                                        $step.addClass('active');
                                        if(lastSection != $(this).data('select-section')){
                                            $navModule.find('.container').scrollLeft($navModule.find('.container').scrollLeft() + $step.position().left - parseInt($navModule.find('.container').css('padding-left')));
                                        }
                                        lastSection = $(this).data('select-section');
                                    }
                                    return false;
                                }
                            });
                        }
                        lastScrollPosition = scrollPosition;
                    }   
                });
                
                refreshInclusionSelect()
            }

            var $complexForm = $('.js-complex-form');
            if($complexForm.length){
                $complexForm.find('[name="land_registration"]').parents('.form-group').hide();
                $complexForm.find('[name="land_registration_date"]').parents('.form-group').hide();
                $complexForm.find('[name="region"]').parents('.form-group').hide();
                $complexForm.find('[name="estate"]').parents('.form-group').hide();
                $complexForm.find('[name="estate_other"]').parents('.form-group').hide();
                $complexForm.find('[name="lot_width"]').parents('.form-group').hide();
                $complexForm.find('[name="address"]').parents('.form-group').hide();
                $complexForm.find('[name="property_status"]').parents('.form-group').hide();

                $complexForm.find('[name="situation"]').on('change', function(){
                    if($complexForm.find('[name="situation"]:checked').val() == 'Looking to build on a vacant block of land'){
                        $complexForm.find('[name="land_registration"]').parents('.form-group').show();
                        $complexForm.find('[name="region"]').parents('.form-group').show();
                        $complexForm.find('[name="estate"]').parents('.form-group').show();
                        $complexForm.find('[name="lot_width"]').parents('.form-group').show();
                        $complexForm.find('[name="lot_number"]').parents('.form-group').show();
                        $complexForm.find('[name="address"]').parents('.form-group').hide();
                        $complexForm.find('[name="property_status"]').parents('.form-group').hide();
                        if($complexForm.find('[name="land_registration"]').val() == 'Unregistered'){
                            $complexForm.find('[name="land_registration_date"]').parents('.form-group').show();
                        }
                        if($complexForm.find('[name="estate"]').val() == 'Other'){
                            $complexForm.find('[name="estate_other"]').parents('.form-group').show();
                        }
                    }else if($complexForm.find('[name="situation"]:checked').val() == 'Planning a knockdown rebuild project'){
                        $complexForm.find('[name="region"]').parents('.form-group').show();
                        $complexForm.find('[name="address"]').parents('.form-group').show();
                        $complexForm.find('[name="property_status"]').parents('.form-group').show();
                        $complexForm.find('[name="lot_width"]').parents('.form-group').hide();
                        $complexForm.find('[name="lot_number"]').parents('.form-group').hide();
                        $complexForm.find('[name="land_registration"]').parents('.form-group').hide();
                        $complexForm.find('[name="land_registration_date"]').parents('.form-group').hide();
                        $complexForm.find('[name="estate"]').parents('.form-group').hide();
                        $complexForm.find('[name="estate_other"]').parents('.form-group').hide();
                    }else{
                        $complexForm.find('[name="land_registration"]').parents('.form-group').hide();
                        $complexForm.find('[name="land_registration_date"]').parents('.form-group').hide();
                        $complexForm.find('[name="region"]').parents('.form-group').hide();
                        $complexForm.find('[name="estate"]').parents('.form-group').hide();
                        $complexForm.find('[name="estate_other"]').parents('.form-group').hide();
                        $complexForm.find('[name="lot_width"]').parents('.form-group').hide();
                        $complexForm.find('[name="lot_number"]').parents('.form-group').hide();
                        $complexForm.find('[name="address"]').parents('.form-group').hide();
                        $complexForm.find('[name="property_status"]').parents('.form-group').hide();
                    }
                });

                $complexForm.find('[name="land_registration"]').on('change', function(){
                    if($(this).val() == 'Unregistered'){
                        $complexForm.find('[name="land_registration_date"]').parents('.form-group').show();
                    }else{
                        $complexForm.find('[name="land_registration_date"]').parents('.form-group').hide();
                    }
                });

                $complexForm.find('[name="region"]').on('change', function(){
                    $complexForm.find('[name="estate"] + .nice-select .option').hide();
                    $complexForm.find('[name="estate"] option[data-region="'+$(this).val()+'"]').each(function(){
                        $complexForm.find('[name="estate"] + .nice-select .option[data-value="'+$(this).val()+'"]').show();
                    });
                    $complexForm.find('[name="estate"] + .nice-select .option:last-child').show();
                    $complexForm.find('[name="estate"]').val('');
                    $complexForm.find('[name="estate"]').trigger('change');
                    $complexForm.find('[name="estate"] + .nice-select .current').text('');
                    $complexForm.find('[name="estate"] + .nice-select .selected').removeClass('selected');
                });

                $complexForm.find('[name="estate"]').on('change', function(){
                    if($(this).val() == 'Other'){
                        $complexForm.find('[name="estate_other"]').parents('.form-group').show();
                    }else{
                        $complexForm.find('[name="estate_other"]').parents('.form-group').hide();
                    }
                });

                $complexForm.find('[name="finance"]').on('change', function(){
                    if($(this).val() == 'I would like a free finance consultation'){
                        $complexForm.find('[name="finance_consent"]').parents('.form-group').show();
                    }else{
                        $complexForm.find('[name="finance_consent"]').parents('.form-group').hide();
                    }
                });
                $complexForm.find('[name="finance"]').trigger('change');
                
                if($('.js-dropdown-options').length > 0){
                    var $dropdownOptions = $('.js-dropdown-options');
                    $.each($dropdownOptions.data('options'), function(key, value){
                        var $dropdown = $dropdownOptions.find('[name="'+key+'"]')
                        $dropdown.html('<option value=""></option>');
                        $.each(value, function(k, v){
                            if(key == 'lot_width'){
                                $dropdown.append('<option value="'+v.width+'">'+v.width+'m+</option>');
                            }else if(key == 'estate'){
                                $dropdown.append('<option data-region="'+v.region_title+'" value="'+v.title+'">'+v.title+'</option>');
                            }else{
                                $dropdown.append('<option value="'+v.title+'">'+v.title+'</option>');
                            }
                        });
                        if(key == 'estate'){
                            $dropdown.append('<option value="Other">Other</option>');
                        }
                        $dropdownOptions.find('.nice-select').niceSelect('update');
                    });
                }

                refreshSelectSections();
            }
        });

        window.refreshSelectSections = function(){
            if($('.js-select-section').length > 0){
                $('.js-select-section').hide();
                $('.js-select-section[data-id="1"]').show();
                $('.js-complex-form .privacy-link').hide();
                
                $('.js-select-section-proceed').off().on('click', function(){
                    $('.js-select-section[data-id="1"]').hide();
                    $('.js-select-section[data-id="2"]').show();
                    $('.js-complex-form .privacy-link').show();
                });
            }
        }
    };

    const refreshInclusionSelect = () => {
        var $select = $('.js-select');
        if($select.length) {
            var $inclusionSelect = $select.find('.js-select-inclusion.active');

            let $overlay = $inclusionSelect.find('.overlay')
            let $inclusionRooms = $('.js-inclusion-rooms')

            $overlay.height($inclusionRooms.height())
        }
    }

    return {
        init: init,
        refreshInclusionSelect: refreshInclusionSelect
    };
};

export default Select;